export const types = ["payment_bonus"];
